const book1Pages = [
    {
        pageNumber: "001",
        heading: "THE FULL SPECTRUM OF LIGHT",
        subtitle: "Transient , Conflicted , and YiN YANG Feelings As Poems Written By Casey Crossman From NEP2YN",
        body: `“i cry because im so thankful for the warmth ,
and i don’t know how to give my warmth back .”`,
      },
  
      {
        pageNumber: "002",
        heading: "BAMN PREFACE",
        body: `SECTiON I - FLUiDiTY , DESiRE , iMAGE
  
  SECTiON II - iSOLATION , SOLiTUDE , LONGiNG
  
  SECTiON III - ?
  
  SECTiON IV - ?`,
      },
      {
        pageNumber: "003",
        heading: "SECTiON I - FLUiDiTY , DESiRE , iMAGE",
      },
    {
        pageNumber: "004",
        subtitle: "SECTION I",
        body: `the wind of the day 
shapes this wave .

its shape 
has never been seen before .

it’s filled with water 
that has never been a wave before .

its impact on the shore 
is different than yesterday .

the islanders 
have only one name 
for this daily event .

then , 
there are those 
seeking experience , 
feeling this unique force 
of potential 
become kinetic .

those who experienced this energy 
now personally ,
in their image ,
know the figure 
who influenced 
their new position , 
their path to be .

this is what the wave desires .

but will this influence of being 
still be the waves desire tomorrow , 
when new wind 
has sculpted a new shape ?

or is this matter 
beyond the waves feelings ?`,
      },
      {
        pageNumber: "005",
        subtitle: "SECTION I",
        body: `the chaos of potential .

i feel static , between frequencies of being .
i find my favorite channel of expression , 
and i tune into it .

a new shell washes upon me ,
now mine in this moment .
i mold to fit this vessel .
to be seen as what i am now . 

as you see me now ,
can you imagine who i was ?
what i am before that selection ?

what are we before an action ?
what all can we be with a decision ?
where all could we go with these manifestations of truth ?

we are limitless now .

i am stone .`,
      },
      {
        pageNumber: "006",
        subtitle: "SECTION I",
        body: `what journey will you become .
who will you find .
where will you be .
who will you be this next moment .

what exodus will be required of you .
what is your genesis from this moment .

the path is for you ,
just beyond me .

after our meeting is finished , 
and i’m so happy to experience what is ours ,
i will remember facing you 
in fate , 
and forever .`,
      },
      {
        pageNumber: "007",
        subtitle: "SECTION I",
        body: `more poems for SECTION I will be written`,
      },
      {
        pageNumber: "008",
        heading: "SECTiON II - iSOLATION , SOLiTUDE , LONGiNG",
      },
      {
        pageNumber: "009",
        subtitle: "SECTION II",
        body: `i feel submerged in the meaning that i’ve created . 
like i must show each piece i’ve called important . 

although , i don’t believe you could feel it the way i feel .

i hold onto the remains of pictures , videos , clothes , and relationships for mainly one reason , because i think they’re special . 

but beyond that, i don’t know why i should keep care of any of it .

hardly any of the pieces are inspiration for me now , 
many of it is nostalgia , 
and all of it i want to show to you ,
but who could care like i do .

the pictures of a moment were part of my night .
the videos recorded were part of my day .
the clothes worn were part of a story .
the drawings made were part of my imagination .

all these moments of family , friends , and art were part of 

my life , 

so why would anyone else care .`,
      },
      {
        pageNumber: "010",
        subtitle: "SECTION II",
        body: `i stop to breathe, and rest .

i look into this fire ,
and i see all my family ,
friends ,
moments ,
experiences ,
art ,
and i cry because im so thankful for the warmth ,
and i don’t know how to give my warmth back .`,
      },
      {
        pageNumber: "011",
        subtitle: "SECTION II",
        body: `more poems for SECTION II will be written`,
      },
      {
        pageNumber: "012",
        subtitle: "SECTION II - SECTION IV",
        body: `writing in progress...`,
      },
  ];
  
  export default book1Pages;